import { Circle, RadioButton } from '@phosphor-icons/react';

import Fieldset from '../shared/Fieldset';
import type { FieldsetProps } from '../shared/Fieldset';

import s from './RadioButtons.module.scss';

type RadioButtonOption = {
  label: string;
  key: string;
};

type RadioButtonsProps = {
  name: string;
  value: string | null;
  onChange?: (value: string | null) => void;
  onBlur?: () => void;
  onFocus?: () => void;
  required?: boolean;
  disabled?: boolean;
  options: RadioButtonOption[];
} & FieldsetProps;

const RadioButtons: React.FC<RadioButtonsProps> = ({
  label,
  description,
  disabled,
  hint,
  error,
  name,
  onChange,
  onBlur,
  onFocus,
  required,
  options,
  value,
}) => (
  <Fieldset
    label={label}
    description={description}
    required={required}
    hint={hint}
    error={error}
    onClear={onChange && value ? () => onChange(null) : undefined}
  >
    <div className={s.container}>
      {options?.map((input) => (
        <label key={input.key}>
          <RadioButton size={20} weight='fill' className={'input-checked'} />
          <Circle size={20} className={'input-unchecked'} />
          <input
            type='radio'
            name={name}
            value={input.key}
            checked={input.key === value}
            onChange={(event) => onChange?.(event.target.value)}
            required={required}
            disabled={disabled}
            onBlur={onBlur}
            onFocus={onFocus}
          />
          {input.label}
        </label>
      ))}
    </div>
  </Fieldset>
);

export default RadioButtons;
